import { render, staticRenderFns } from "./LedgerInfoDetails.vue?vue&type=template&id=615a1111&scoped=true"
import script from "./LedgerInfoDetails.vue?vue&type=script&lang=ts"
export * from "./LedgerInfoDetails.vue?vue&type=script&lang=ts"
import style0 from "./LedgerInfoDetails.vue?vue&type=style&index=0&id=615a1111&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615a1111",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('615a1111')) {
      api.createRecord('615a1111', component.options)
    } else {
      api.reload('615a1111', component.options)
    }
    module.hot.accept("./LedgerInfoDetails.vue?vue&type=template&id=615a1111&scoped=true", function () {
      api.rerender('615a1111', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ledgers/components/LedgerInfoDetails.vue"
export default component.exports